import { render, staticRenderFns } from "./edit-partner.vue?vue&type=template&id=e22ead1c&scoped=true&"
import script from "./edit-partner.vue?vue&type=script&lang=js&"
export * from "./edit-partner.vue?vue&type=script&lang=js&"
import style0 from "./edit-partner.vue?vue&type=style&index=0&id=e22ead1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22ead1c",
  null
  
)

export default component.exports